/* eslint-disable */

import React from 'react'
import { createScope, map, transformProxies } from './helpers'

const scripts = [

]

let Controller

class EmailFormBottomView extends React.Component {
  static get Controller() {
    if (Controller) return Controller

    try {
      Controller = require('../controllers/EmailFormBottomController')
      Controller = Controller.default || Controller

      return Controller
    }
    catch (e) {
      if (e.code == 'MODULE_NOT_FOUND') {
        Controller = EmailFormBottomView

        return Controller
      }

      throw e
    }
  }

  componentDidMount() {
    /* View has no WebFlow data attributes */

    scripts.concat(null).reduce((active, next) => Promise.resolve(active).then((active) => {
      const loading = active.loading.then((script) => {
        new Function(`
          with (this) {
            eval(arguments[0])
          }
        `).call(window, script)

        return next
      })

      return active.isAsync ? next : loading
    }))
  }

  render() {
    const proxies = EmailFormBottomView.Controller !== EmailFormBottomView ? transformProxies(this.props.children) : {
      'email-bottom': [],
      'submit-bottom': [],
      'form-fail-bottom': [],
    }

    return (
      <span>
        <style dangerouslySetInnerHTML={{ __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/steady-landing-page.webflow.css);
        ` }} />
        <span className="af-view">
          <div className="af-class-form-block-2 w-form">
            <form id="email-form" name="email-form" data-name="Email Form" redirect="https://heysteady.typeform.com/to/l7c0reLV" data-redirect="https://heysteady.typeform.com/to/l7c0reLV" className="af-class-form-2">{map(proxies['email-bottom'], props => <input type="email" maxLength={256} name="email-3" data-name="Email 3" placeholder="Enter your email" id="email-3" required {...{...props, className: `af-class-text-field-4 w-input ${props.className || ''}`}}>{props.children}</input>)}{map(proxies['submit-bottom'], props => <input type="submit" value="Get Early Access" data-wait="Please wait..." {...{...props, className: `af-class-submit-button-2 w-button ${props.className || ''}`}}>{props.children}</input>)}</form>
            <div className="w-form-done">
              <div>Thank you! Your submission has been received!</div>
            </div>
            {map(proxies['form-fail-bottom'], props => <div {...{...props, className: `w-form-fail ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>
              <div>Oops! Something went wrong while submitting the form.</div>
            </React.Fragment>}</div>)}
          </div>
        </span>
      </span>
    )
  }
}

export default EmailFormBottomView

/* eslint-enable */